import React from "react";

import { Link } from "@at/design-system-elements";
import { TypeFiesta } from "@at/design-system-foundation";

import * as Styles from "../leasing-modal-hub.styled";

export const LeasingFreeDeliveryModal = () => {
  return (
    <>
      <Styles.LeasingProductModalHeaderAndParagraphContainer>
        <Styles.LeasingProductModalHeader>
          Free delivery to your door
        </Styles.LeasingProductModalHeader>
        <Styles.LeasingProductModalParagraph>
          There&apos;s no need to worry about collecting your brand-new vehicle
          yourself - we&apos;ll take care of everything.
        </Styles.LeasingProductModalParagraph>
        <Styles.LeasingProductModalParagraph>
          As soon as it&apos;s ready, we&apos;ll arrange a delivery date and
          time that suits you, and deliver it to your home address for free!
        </Styles.LeasingProductModalParagraph>
      </Styles.LeasingProductModalHeaderAndParagraphContainer>
      <Styles.LeasingProductModalHeaderAndParagraphContainer>
        <Styles.LeasingProductModalInfoBlock>
          <Styles.LeasingProductModalParagraph>
            <TypeFiesta weight="600" as="span">
              Good to know:
            </TypeFiesta>{" "}
            We can only deliver to Mainland UK, excluding Northern Ireland.
          </Styles.LeasingProductModalParagraph>
        </Styles.LeasingProductModalInfoBlock>
      </Styles.LeasingProductModalHeaderAndParagraphContainer>
      <Styles.LeasingProductModalHeaderAndParagraphContainer>
        <Styles.LeasingProductModalParagraph>
          Want to know more?{" "}
          <Link
            href="https://www.autotrader.co.uk/terms-and-conditions/vanarama"
            routerLink={false}
            attributes={{
              target: "_blank",
            }}
          >
            Read our Terms and Conditions
          </Link>{" "}
          for all the legal bits.
        </Styles.LeasingProductModalParagraph>
      </Styles.LeasingProductModalHeaderAndParagraphContainer>
    </>
  );
};
